// extracted by mini-css-extract-plugin
export default {"productGallery":"MJ-z","inQuickShop":"NJ-z"};